import React from "react";

export default function Section5() {
  const shopifyOnlyServices = [
    {
      title: "Shopify-Focused Expertise",
      description:
        "We specialize in building Shopify stores that are structured properly from day one, ensuring smooth performance and long-term reliability.",
    },
    {
      title: " End-to-End  Execution",
      description:
        "From initial planning to launch, our team handles every step carefully, so your project stays consistent, organized, and on schedule.",
    },
    {
      title: "Customer-Friendly Design",
      description:
        "We design simple navigation and clean layouts that help visitors find products easily and complete purchases with confidence.",
    },
    {
      title: "Ongoing Support",
      description:
        "As your business grows, we provide continuous updates and technical support to keep your Shopify store performing at its best.",
    },
    {
      title: "Tailored to Your Business",
      description:
        "No two businesses are the same. We take the time to understand your brand, audience, and goals, creating a Shopify experience that’s uniquely yours.",
    },
    
  ];

  return (
    <div className="w-full Section4 mt-[14%] md:mt-[4%]">
      <div className="w-full mx-auto section4-container">
        <h2 className="w-[90%] md:w-[61%] mx-auto text-center text-[26px] md:text-[34px] leading-[32px] md:leading-[41px] text-[#151515] font-bold my-[0.67em]">
          Why Businesses Across New York Choose Mean3
        </h2>

        <div className="boxes w-[85%] xs:w-full md:w-[85%] flex justify-center gap-x-[2%] gap-y-[19px] md:gap-y-[30px] flex-wrap mx-auto p-[2%_0px_4%_0px]">
          {/* Shopify-only Cards */}
          {shopifyOnlyServices.map((service, index) => (
            <div
              key={index}
              className={`w-full xs:w-[45%] md:w-[30%] p-[10%] xs:p-[3%] rounded-[8px] ${
                index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#F5F5F5] text-[#373737]"
              }`}
            >
              <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {service.title}
              </h2>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
